module.exports = __webpack_public_path__ + "VIPG7.png?dd1db3004c2f848951b3248ce0bad1a3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/greyhounds/VIPG7.png
// module id = 79
// module chunks = 0